import * as React from "react"

import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

import FitnessItem from '../FitnessItem';

export default function FitnessList() {
  return (
    <S.Container>
      <h1>Explore our Fitness Pros</h1>
      <S.Wrapper>
        <S.Content>
          <S.Items>
            <FitnessItem />
            <FitnessItem />
            <FitnessItem />
            <FitnessItem />
            <FitnessItem />
            <FitnessItem />
          </S.Items>
        </S.Content>
        <S.Footer>
          <StaticImage
            src={`../../images/footer.png`}
            alt="Background footer"
            placeholder="blurred"
            layout="constrained"
          />
        </S.Footer> 
      </S.Wrapper>
    </S.Container>
  )
}